export default __webpack_public_path__ + "static/media/certificates.1f90a938.png";